import React from 'react';
import withData from '../../../../core/containers/withData';
import { buildStatsRow } from '../../../../utils';
import { orderBy } from 'lodash';
import './AccumulatedStatsTeamRank.css';

class AccumulatedStatsTeamRank extends React.Component {
  getTeamRank(data, sortBy, sortOrder) {
    const { team } = this.props;

    const sorted = orderBy(data, [sortBy], [sortOrder]);
    const orderedTeamIds = sorted.map(row => row.team_id.toString());
    const rank = orderedTeamIds.indexOf(team) + 1;

    return {
      rank,
      last25: (rank >= orderedTeamIds.length * 3/4)
    };
  }

  renderColumns() {
    const { data } = this.props;

    if (!data || !data.length) {
      return null;
    }

    data.map(row => {
      return buildStatsRow(row);
    });

    let columns = [];

    [
      { metric: 'points', sortOrder: 'desc' },
      { metric: 'q1_points', sortOrder: 'desc' },
      { metric: 'q2_points', sortOrder: 'desc' },
      { metric: 'q3_points', sortOrder: 'desc' },
      { metric: 'q4_points', sortOrder: 'desc' },
      { metric: 'fg_made', sortOrder: 'desc' },
      { metric: 'fg_attempts', sortOrder: 'desc' },
      { metric: 'fg_percent', sortOrder: 'desc' },
      { metric: 'p3_made', sortOrder: 'desc' },
      { metric: 'p3_attempts', sortOrder: 'desc' },
      { metric: 'p3_percent', sortOrder: 'desc' },
      { metric: 'p2_made', sortOrder: 'desc' },
      { metric: 'p2_attempts', sortOrder: 'desc' },
      { metric: 'p2_percent', sortOrder: 'desc' },
      { metric: 'ft_made', sortOrder: 'desc' },
      { metric: 'ft_attempts', sortOrder: 'desc' },
      { metric: 'ft_percent', sortOrder: 'desc' },
      { metric: 'of_rebounds', sortOrder: 'desc' },
      { metric: 'df_rebounds', sortOrder: 'desc' },
      { metric: 'assists', sortOrder: 'desc' },
      { metric: 'turnovers', sortOrder: 'asc' },
      { metric: 'steals', sortOrder: 'desc' },
      { metric: 'block_shots', sortOrder: 'desc' },
      { metric: 'shots_rejected', sortOrder: 'asc' },
      { metric: 'fouls_made', sortOrder: 'desc' },
      { metric: 'fouls_received', sortOrder: 'desc' }
    ].map(item => {
      const rank = this.getTeamRank(data, item.metric, item.sortOrder);
      let className = "";
      switch (rank.rank) {
        case 1:
          className = "1";
          break;
        case 2:
          className = "2";
          break;
        case 3:
          className = "3";
          break;
        default:
          className = "default";
      }
      if (rank.last25) {
        className = "last-25";
      }
      return columns.push(
        <td key={ item.metric }>
          <span className={ `label label-rank label-rank-${className}` }>
            #{ rank.rank }
          </span>
        </td>
      );
    });

    return columns;
  }

  render() {
    return (
      <tr>
        <td><strong>Rank</strong></td>
        <td></td>
        { this.renderColumns() }
      </tr>
    );
  }
};

export default withData(AccumulatedStatsTeamRank);



// WEBPACK FOOTER //
// ./src/features/scout-report/components/AccumulatedStatsTeamRank/AccumulatedStatsTeamRank.js